<template>
  <div class="basic-setting-content pl16 pr16">
    <!--商品详情-->
    <div class="common-form" style="font-size: 20px">使用方法</div>
    <el-table size="small" :data="form.model.usageList" border style="width: 100%">
      <el-table-column prop="cropTypeName" label="作物分类">
      </el-table-column>
      <el-table-column prop="cropName" label="作物"></el-table-column>
      <el-table-column prop="diseaseName" label="防治对象">
      </el-table-column>
      <el-table-column prop="formulationDosage" label="制剂和用药量">
      </el-table-column>
      <el-table-column prop="useMethod" label="使用方法">
      </el-table-column>
      <!--      <el-table-column prop="isPicture" label="图片" width="100">-->
      <!--        <template slot-scope="scope">-->
      <!--          <span v-if="scope.row.isPicture==0">没有</span>-->
      <!--          <span v-else>有</span>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--          <el-table-column prop="sort" label="排序" width="100"></el-table-column>-->
      <!--      <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>-->
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="editClick(scope.row)" type="text" size="small">
            编辑
          </el-button>
          <el-button @click="delClick(scope.row,scope.$index)" type="text" size="small">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button size="small" class="el-icon-circle-plus m-v-15" @click="addUsageClick">
      添加方法
    </el-button>

    <el-dialog title="添加使用方法" :visible.sync="dialogVisible" @close="dialogFormVisible"
               :close-on-press-escape="false"
               top="5vh">
      <div style="display: block">
        <el-form size="mini" ref="editform" :model="editform">
          <el-form-item prop="cropDiseaseList" label="作物病害:"
                        :rules="[{ required: true, message: '请选择作物病害' }]">
            <el-cascader :options="form.diseaseList" style="width: 460px"
                         :props="{ checkStrictly: true,value:'id',label:'name',children:'children' }"
                         v-model="editform.cropDiseaseList"
                         ref="cropDiseaseList"
                         @change="changeCropDiseaseList"
                         filterable
                         clearable></el-cascader>
          </el-form-item>
          <el-form-item prop="formulationDosage" label="制剂用药量:"
                        :rules="[{ required: true, message: '请填写制剂用药量' }]">
            <el-input v-model="editform.formulationDosage" style="width: 460px"></el-input>
          </el-form-item>
          <el-form-item prop="useMethod" label="使用方法:" :rules="[{ required: true, message: '请选择使用方法' }]">
            <el-select v-model="editform.useMethod" style="width: 460px">
              <el-option v-for="(item,index) in methodList" :value="item.value" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <!--          <el-form-item label="应用图例：">-->
          <!--            <div class="draggable-list">-->
          <!--              <draggable class="wrapper" v-model="editform.imageList">-->
          <!--                <transition-group>-->
          <!--                  <div class="item" v-for="(item, index) in editform.imageList" :key="item + index">-->
          <!--                    <img v-img-url="item.filePath"/>-->
          <!--                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i-->
          <!--                      class="el-icon-close"></i></a>-->
          <!--                  </div>-->
          <!--                </transition-group>-->
          <!--              </draggable>-->
          <!--              <div class="item img-select" @click="openProductUpload('image', 'imageList')"><i class="el-icon-plus"></i>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </el-form-item>-->
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="addUsage">确 定</el-button>
      </div>
    </el-dialog>
    <!--    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">-->
    <!--      上传图片-->
    <!--    </Upload>-->
  </div>
</template>

<script>
import Upload from '@/components/file/Upload'
import draggable from 'vuedraggable'

export default {
  name: 'ProUsage',
  components: {
    draggable,
    Upload
  },
  data () {
    return {
      methodList: [
        {
          id: 1,
          value: '喷雾'
        }, {
          id: 2,
          value: '滴灌'
        }, {
          id: 3,
          value: '冲施'
        }, {
          id: 4,
          value: '撒施'
        }, {
          id: 5,
          value: '穴施'
        }, {
          id: 6,
          value: '淋根'
        }, {
          id: 7,
          value: '飞防'
        }, {
          id: 8,
          value: '沟施'
        },
      ],
      config: {},
      file_name: 'image',
      dialogVisible: false,
      isProductUpload: false,
      editform: {
        cropDiseaseList: [],
        productId: 0,
        formulationDosage: '',
        useMethod: '',
        imageList: [],
        productName: '',
        cropTypeId: 0,
        cropTypeName: '',
        cropId: 0,
        cropName: '',
        diseaseId: 0,
        diseaseName: ''
      },
      selectRow: null
    }
  },
  inject: ['form'],
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    addUsageClick () {
      this.selectRow = null
      this.editform = {
        cropDiseaseList: [],
        formulationDosage: '',
        useMethod: '',
        imageList: [],
        productId: this.form.model.productId,
        productName: this.form.model.productName || '',
      }
      this.dialogVisible = true
    },
    dialogFormVisible (e) {
      this.editform = {
        cropDiseaseList: [],
        productId: 0,
        formulationDosage: '',
        useMethod: '',
        imageList: [],
        productName: ''
      }
    },
    openProductUpload: function (file_type, file_name) {
      this.file_name = file_name
      if (this.file_name === 'imageList') {
        this.config = {
          total: 9,
          fileType: file_type
        }
      }
      this.isProductUpload = true
    },
    returnProductImgsFunc (e) {
      if (e != null) {
        // 兼容后端
        if (e.length > 0) {
          if (this.file_name === 'imageList') {
            this.editform.imageList = this.editform.imageList.concat(e)
          }
        }
      }
      this.isProductUpload = false
    },
    /*删除商品图片*/
    deleteImg (index) {
      this.editform.imageList.splice(index, 1)
    },
    changeCropDiseaseList () {
      let item = this.$refs['cropDiseaseList'].getCheckedNodes()
      let nodeData = item[0]
      this.editform.cropTypeId = 0
      this.editform.cropTypeName = ''
      this.editform.cropId = 0
      this.editform.cropName = ''
      this.editform.diseaseId = 0
      this.editform.diseaseName = ''
      this.fomatData(nodeData)
    },
    fomatData (nodeData) {
      let itemData = nodeData.data
      let level = itemData.level
      if (level === 2) {
        this.editform.diseaseId = itemData.id
        this.editform.diseaseName = itemData.name
      } else if (level === 1) {
        this.editform.cropId = itemData.id
        this.editform.cropName = itemData.name
      } else if (level === 0) {
        this.editform.cropTypeId = itemData.id
        this.editform.cropTypeName = itemData.name
      }
      if (nodeData.parent) {
        this.fomatData(nodeData.parent)
      }
    },
    delClick: function (row, index) {
      this.form.model.usageList.splice(index, 1)
    },
    addUsage () {
      let self = this
      this.$refs.editform.validate((valid) => {
        if (valid) {
          if (!self.selectRow) {
            self.form.model.usageList.push(self.editform)
          } else {
            Object.assign(self.selectRow, self.editform)
          }
          self.dialogVisible = false
        }
      })

    },
    editClick (row) {
      this.selectRow = row
      let cropDiseaseList = []
      let cropTypeId = row.cropTypeId || 0
      if (cropTypeId) {
        cropDiseaseList.push(cropTypeId)
        let cropId = row.cropId || 0
        if (cropId) {
          cropDiseaseList.push(cropId)
          let diseaseId = row.diseaseId || 0
          if (diseaseId) {
            cropDiseaseList.push(diseaseId)
          }
        }
      }
      this.editform = {
        id: row.id || 0,
        cropDiseaseList: cropDiseaseList,
        formulationDosage: row.formulationDosage || '',
        useMethod: row.useMethod || '',
        imageList: row.imageList || [],
      }
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/product/product/part/ProUsage.vue